module.exports = __webpack_public_path__ + "img/gray_check.9327e546.svg";